import { useEffect } from 'react';
import { signupWithGoogle } from 'resources/auth/workflows';
import userService from 'resources/user/user.service';
import { useCurrentUser } from 'resources/user/hooks';

export default function useTrySignUpWithGoogle({ session, setIsLoading }) {
  const { isLoading: isUserLoading, data: user, refetch: refetchUser } = useCurrentUser();

  useEffect(() => {
    if (isUserLoading || user) return;

    const trySignUpWithGoogle = async () => {
      if (session?.user?.app_metadata?.providers.includes('google')) {
        setIsLoading(true);

        const existingUser = await userService.findByEmail(session.user.email);
        if (!existingUser) {
          await signupWithGoogle(session.user);
        }

        await refetchUser();

        setIsLoading(false);
      }
    };

    trySignUpWithGoogle();
  }, [session, setIsLoading, refetchUser]);
}